import { ReactNode, useState, useEffect, useContext, useCallback, createContext } from 'react';
import { FEATURE_FLAGS_KEYS } from '../constants/featureFlags';
import { requestHandler } from '../utils';
import UserContext from './userContext';

type FeatureFlagsContextValue = {
    [K in keyof typeof FEATURE_FLAGS_KEYS]?: boolean;
};

async function getFeatureFlags() {
    let res = null;
    const { success, payload } = await requestHandler('GET', '/api/feature-flag');
    if (success) {
        res = payload as FeatureFlagsContextValue;
    }
    return res;
}

const FeatureFlagsContext = createContext<FeatureFlagsContextValue>({});

const FeatureFlagsProvider = ({ children }: { children: ReactNode }) => {
    const { activeClient } = useContext(UserContext);

    const getFeatureFlagsValue = useCallback(async () => {
        if (!activeClient?.id) return;
        const FEATURE_FLAGS = await getFeatureFlags();
        if (FEATURE_FLAGS) {
            // Check the user role and return a simple flag object based on that parameter
            setFeatureFlags(FEATURE_FLAGS);
        }
    }, [activeClient]);

    useEffect(() => {
        getFeatureFlagsValue();
    }, [getFeatureFlagsValue]);

    const [featureFlags, setFeatureFlags] = useState<FeatureFlagsContextValue>({});

    return (
        <FeatureFlagsContext.Provider value={featureFlags}>{children}</FeatureFlagsContext.Provider>
    );
};

export { FeatureFlagsContext, FeatureFlagsProvider };
